'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _format = require('./utils/format.js');

var _format2 = _interopRequireDefault(_format);

var _atob = require('./utils/atob');

var _atob2 = _interopRequireDefault(_atob);

var _gzip = require('./utils/gzip');

var _gzip2 = _interopRequireDefault(_gzip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var accsResponse = function () {
  function accsResponse(jsonStr) {
    _classCallCheck(this, accsResponse);

    var message = JSON.parse(jsonStr);
    for (var k in message) {
      if (message.hasOwnProperty(k)) {
        this[k] = message[k];
      }
    }
  }

  _createClass(accsResponse, [{
    key: 'getText',
    value: function getText() {
      if (!this.data) {
        return '';
      }
      return _format2.default.utf8ToUtf16((0, _atob2.default)(this.data));
    }
  }, {
    key: 'getBinaryArray',
    value: function getBinaryArray() {
      var _this = this;

      var p = new Promise(function (resolve) {
        if (!_this.data) {
          resolve([]);
          return;
        }
        var dataTxt = (0, _atob2.default)(_this.data); // 获取转成utf16的字节流
        var compressType = _this.compressType || 'COMMON'; // COMMON——无压缩，GZIP——gzip压缩，ZLIB——zlib压缩，INVALID——错误的压缩类型
        var uint8arr = _format2.default.binaryStringToBinaryArray(dataTxt);
        if (String(compressType) === 'GZIP') {
          // 使用gzip解压
          // gzip压缩，解压消息
          var options = {
            level: 6,
            name: '',
            timestamp: parseInt(Date.now() / 1000, 10)
          };
          // gzip解码
          uint8arr = new Uint8Array(_gzip2.default.unzip(uint8arr, options));
          resolve(uint8arr);
        } else {
          resolve(uint8arr);
        }
      });
      return p;
    }
  }]);

  return accsResponse;
}();

exports.default = accsResponse;